import { supabase } from './client';

const rpc = async (name, params) => {
    const { data, error } = await supabase.rpc(name, params);
    if (error) throw new Error(error.message);
    return data;
};

export const generateFormSubmissionID = () => rpc('generate_form_submission_id', {});
export const getFormPaymentOptions = (formID) => rpc('get_form_payment_options', { p_form_id: formID || null });
export const getFormPaymentDetails = (entryID, search = null) => rpc('get_form_payment_details', { p_entry_id: entryID, p_search: search });
export const manageFormPayment = (entryID, action, details) => rpc('manage_form_payment', { p_entry_id: entryID, p_action: action, p_details: details });

export const formPaymentRequest = async (body) => {
    const { data, error } = await supabase.functions.invoke('form-payment', { body });
    if (error) {
        let message = 'Payment could not be confirmed. Your entry is saved; check its status before retrying.';
        try {
            const response = await error.context?.json();
            if (response?.error) message = response.error;
        } catch { message = error.message || message; }
        throw new Error(message);
    }
    return data;
};

export const getFormPaymentLink = (token) => `${process.env.EXPO_PUBLIC_APP_WEB_URL || 'https://app.reachchms.com'}/form-payment#${token}`;
export const paymentStatusLabels = { UNPAID: 'Unpaid', PENDING: 'Pending', PAID: 'Paid', NOT_REQUIRED: 'Not Required' };
export const formatPaymentAmount = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
